import React from 'react';
import axios from 'axios';
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import AwardForm from "./AwardForm";
import AwardPreview from "./AwardPreview";
import AwardList from "./AwardList";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css';

class Awards extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            size: {
                width: 200,
                height: 200
            }
        };

        this.handleAddAward = this.handleAddAward.bind(this);
        this.handleEditAward = this.handleEditAward.bind(this);
        this.handleRemoveAward = this.handleRemoveAward.bind(this);
        this.handleChangeAvailability = this.handleChangeAvailability.bind(this);
    }

    handleAddAward(values) {
        let token = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        axios.post(this.props.api.awards, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Odměna ' + response.data.name + ' byla vytvořena.');
            this.props.history.push('/awards');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Odměnu se nepodařilo vytvořit!');
            this.props.history.push('/awards');
            console.error('Axios error:', error);
        });
    }

    handleEditAward(values) {
        let token = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        axios.put(this.props.api.awards + "/" + values.id, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Odměna ' + response.data.name + ' byla upravena.');
            this.props.history.push('/awards');
        }).catch(function (error) {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Odměnu se nepodařilo upravit!');
            this.props.history.push('/awards');
            console.error('Axios error:', error);
        });
    }

    handleRemoveAward(award) {
        let token = this.props.sessionData.accessToken;
        let config = {
            headers: {
            'Authorization': 'Bearer ' + token
            }
        };
        axios.delete(this.props.api.awards + "/" + award.id, config)
        .then((response) => {
            if (!this._calledComponentWillUnmount) {
                this.props.addNotification('success', response.status, 'Odměna ' + award.name + ' byla odstraněna.');
            }
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Odměnu se nepodařilo odstranit!');
            console.log("Axios error: ", error);
        });
    }

  handleChangeAvailability(award){
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };

    const availability = !award.availability;

    axios.put(this.props.api.awards + "/" + award.id, {
      availability
    }, config).then((response) => {
      if (!award.availability) {
        this.props.addNotification('success', response.status, 'Odměna ' + award.name + ' byla povolena.');
      } else {
        this.props.addNotification('success', response.status, 'Odměna ' + award.name + ' byla zakázána.');
      }
    }).catch((error) => {
      this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Odměnu se nepodařilo '+(availability ? 'povolit' :  'zakázat')+'!');
      console.log("Axios error: ", error);
    })
  }

    render() {
        let {size} = this.state;

        return (
            /* page content */
            <div id="award-page" className="right-col" role="main">
                <div className="page-title">
                    <h3>Odměny</h3>
                </div>
                <Switch>
                    <Route exact path="/awards" component={
                        (props) =>
                            <AwardList
                                {...this.props}
                                handleRemoveAward={this.handleRemoveAward}
                                handleChangeAvailability={this.handleChangeAvailability}
                            />
                        }
                    />
                    <Route path="/awards/preview/:id" component={
                        (props) =>
                            <AwardPreview
                                {...this.props}
                            />
                        }
                    />
                    <Route path="/awards/add" component={
                        (props) =>
                            <AwardForm
                                {...this.props}
                                title="Formulář pro přidání odměny"
                                button="Přidat"
                                size={size}
                                action={this.handleAddAward}
                            />
                        }
                    />
                    <Route path="/awards/edit/:id" component={
                        (props) =>
                            <AwardForm
                                {...this.props}
                                title="Formulář pro úpravu odměny"
                                button="Upravit"
                                size={size}
                                action={this.handleEditAward}
                            />
                    }
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Awards));




/** WEBPACK FOOTER **
 ** ./src/containers/Awards/index.js
 **/